
import { Button, ButtonStyle, connectDisconnectIntegration, createIntegrationData, getIntegrationsStatus, getButtonClass,
        Image, imageSize, PageStyle, React, REDIRECT, Styles, Table, TableBody, TableCell, TableContainer, TableHead, toastr,
        TableRow, useEffect, useState, useRef, useSWR, useTranslation, useRouter, getMyIntegrationData, motion, PAGE_ANIMATION_OPTIONS,
        ErrorPages, ClientDashboard, SidebarAction, ActivitiesAction, SkipModal, getSession, QuickAdd, CustomToastrAction, IntegrationPopup, InfoIcon } from "@/imports-files/pages/clients/activities/my-integrations";
  


function MyIntegrations(props) {
  const [apiError, setApiError]                                  =    useState(null);
  const activitiesAction                                         =    new ActivitiesAction(setApiError);
  const errorPages                                               =    new ErrorPages()
  const [my_integrations_array, set_my_integrations_array]       =    useState([]);
  const { t, i18n }                                              =    useTranslation();
  const router                                                   =    useRouter();
  const [enable_items, setEnableItems]                           =    useState('')
  const { data, error }                                          =    useSWR('my_integration_data', () => { return getMyIntegrationData(router, setApiError) });
  const [isLoading, setLoading]                                  =    useState(true);
  const step                                                     =    router.query.step
  const isQuickSetup                                             =    router.query.step && router.query.step == 'my_integrations' ? true : false
  const [skipModal, setSkipModal]                                =    useState(false);
  const [session, setSession]                                    =    useState(props.session);
  const [showPopup, setShowPopup]                                =    useState(false);
  const customToastrAction                                       =    new CustomToastrAction();  
  const slack_document_url = process.env.NEXT_PUBLIC_CHARLIE_HR ? "https://help.charliehr.com/en/articles/9149335-connecting-charlie-recruit-to-slack" : "https://www.wearecandidly.com/slack-integration"
  const zoom_document_url = process.env.NEXT_PUBLIC_CHARLIE_HR ? "https://charliehr-public.s3.eu-west-2.amazonaws.com/Zoom+integration.pdf" : "https://candidly-public.s3.eu-west-2.amazonaws.com/Zoom+Video+Interview.pdf"
  useEffect(() => {
    if (data) {
      let integrations        =   data.props.my_integrations;
      let integrations_array  =   [];

      integrations?.map((x, index) => {
        let file_name = x.integration.display_name.toLowerCase().replaceAll(' ', '_');
        let logo_url = `/images/pages/integration/${file_name}.png`
        integrations_array.push(createIntegrationData(index, x.id, x.integration.id, x.integration.slug, x.integration.display_name, x.integration.description, x.integration.user_enabled, x.integration.is_linkable,
          <Image src={logo_url} alt='' width={imageSize(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).width} height={imageSize(x.integration.display_name.toLowerCase().replace(/\s/g, "_")).height}></Image>,
          x.accessible,
          x.connected,
          x.integration.redirect_url
        ))
      });
      set_my_integrations_array(integrations_array);
      setEnableItems(integrations_array);
      if (router.query?.success == 'true') {
        customToastrAction.setNormalToastr(t('page:clients:integrations:errors:connect_success'), 'success');
        // toastr.success(t('page:clients:integrations:errors:connect_success'));
        if(router.query?.step){
          router.push({
            pathname: REDIRECT.client.quick_setup_page,
            query: {step: 'my_integrations'}
          })
        }
        else {
          window.history.replaceState(null, null, REDIRECT.client.my_integrations);  
        }
        router.query = {}
      }
      else if (router.query?.success == 'false') {
        // customToastrAction.setNormalToastr(t('page:clients:integrations:errors:connect_error'), 'warning');
        customToastrAction.setNormalToastr(router.query.message != null ? router.query.message : t('page:clients:integrations:errors:connect_error'), 'warning');
        // toastr.warning(t('page:clients:integrations:errors:connect_error'))
        if(router.query?.step){
          router.push({
            pathname: REDIRECT.client.quick_setup_page,
            query: {step: 'my_integrations'}
          })
        }
        else {
          window.history.replaceState(null, null, REDIRECT.client.my_integrations);  
        }
        router.query = {}
      }

      if(isQuickSetup) 
        setTimeout(() => {
        new SidebarAction().subsidebarQuickSetupChangeIcon(data.props.integration_data.data.sidebar_options.complete_steps, 'my_integrations');
     }, 750);

      setLoading(false);
    }

  }, [data, set_my_integrations_array, setEnableItems, setLoading])





  if(isLoading || error || errorPages.handleErrorCodes(apiError?.status))
  {
    var renderPage  =  (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : null;
    return renderPage; 
  } 

  function cronofyConnectedOrNot(step, router){
    let cronofy = enable_items.filter((x) => x.slug == "cronofy")[0]
    if(cronofy && cronofy.connected){
      activitiesAction.nextOnboardingStep(step, router)
    }
    else{
      customToastrAction.setNormalToastr('To proceed you need to connect cronofy.', 'warning');
      // toastr.warning('To proceed you need to connect cronofy.')
    }
  }

  const handleOpenPopup = () => {
    setShowPopup(true);
  };

  const handleClosePopup = () => {
  setShowPopup(false);
  };

  return (
    <div className="DashboardPageContent">
      <motion.div initial="pageInitial" animate="pageAnimate" exit="pageExit" variants={PAGE_ANIMATION_OPTIONS} transition={{ delay: 0.2 }}>
        <div className={PageStyle.ClientCompany__Container}>

          {session?.role != 'reviewer' && <div className={PageStyle.ClientCompany__TopSection2}>
            <div className={PageStyle.JobList__QuickAdd}>
              <QuickAdd session={session}/>
            </div>
          </div>}

          <div className={PageStyle.ClientCompany__FormSection}>
            <h1 className={`mt0 ${PageStyle.ClientCompany__Heading}`}>{t('page:clients:my-integrations:texts:title')}</h1>
            <h4 className={PageStyle.ClientCompany__Subheading}>
              In order to use the following functionality please connect the tools you use with Charlie Recruit. If you have any questions or concerns you can contact us on <a href="mailto:recruitsupport@charliehr.com" className = {`td-underline`}>recruitsupport@charliehr.com </a>
            </h4>
          </div>

          {enable_items.length > 0 ?
          (<div className={`${Styles.IntegrationView}`}>
            <div className={`${Styles.IntegrationView__Title}`}>
                <h1>Automatic Interview Scheduling</h1>
            </div>
            <div className={`${Styles.IntegrationView__Subheading}`}>
              <p className={`mt10`}>Allow candidates to choose a date and time for interviews from your calendar availability using Cronofy.<br/>
                *Please note: To use Google Meet as your video conferencing tool you must connect Cronofy to <strong>Google Calendar</strong></p>
            </div>
             <div className= {`${Styles.IntegrationView}`}>{enable_items.map((card, index) => {
                if (card.name == "Cronofy"){
                  return (
                    <div className={`${Styles.IntegrationView__BoxWidth} w100`} key={index}>
                      <div className={`${Styles.IntegrationView__Box}`}>
                        <div className={`${Styles.IntegrationView__BoxImage}`}>
                          {card.logo}
                        </div>
                        <div className={`${Styles.IntegrationView__ConnectButton}`}>
                            <Button buttonstyle={getButtonClass(card)} onClick={async (e) => {
                                const result = await connectDisconnectIntegration(e, router, card, setApiError)
                                  if (result && !result.connected) {
                                    console.log(result);
                                    enable_items[card.index] = result
                                    setEnableItems([...enable_items]);
                                  }
                                }}>
                                {getIntegrationsStatus(card, t)}
                            </Button>
                        </div>
                      </div>
                    </div>
                  );
                }
             })}
            </div>
          </div>) : ''}


          {enable_items.length > 0 ?
          (<div className={`${Styles.IntegrationView}`}>
            <div className={`${Styles.IntegrationView__Title}`}>
                <h1>Email Candidates</h1>
            </div>
            <div className={`${Styles.IntegrationView__Subheading}`}>
              <p className={`mt10`}>Connect your email provider in order to send emails to candidates directly from the product</p>
            </div>
             <div className={`${Styles.IntegrationView__FlexFlow}`}>{enable_items.map((card, index) => {
                if ((card.name == "Gmail") || (card.name == "Microsoft") ){
                  return (
                    <div className={`${Styles.IntegrationView__BoxWidth} ${Styles.IntegrationView__w100}`} key={index}>
                      <div className={`${Styles.IntegrationView__Box}`}>
                        <div className={`${Styles.IntegrationView__BoxImage}`}>
                          {card.logo}
                        </div>
                        <div className={`${Styles.IntegrationView__ConnectButton}`}>
                        {card.name == 'Gmail' && getIntegrationsStatus(card, t) == t('page:clients:integrations:texts:connect') ? (<div className={`${Styles.IntegrationView__GoogleButton}`}> <Button buttonstyle={`signingooglebtn`} onClick={async (e) => {
                        if (card.is_linkable)
                        {
                          const result = await connectDisconnectIntegration(e, router, card, setApiError)
                          if (result && !result.connected) {
                            enable_items[card.index] = result
                            setEnableItems([...enable_items]);
                          }
                        }}
                      }>
                        <div className="signingoogle">
                        <img src="/images/pages/integration/gicon.png" alt=""></img>
                        Sign in with Google
                        </div>
                      </Button>
                      </div>)
                    : <Button buttonstyle={getButtonClass(card)} onClick={async (e) => {
                        const result = await connectDisconnectIntegration(e, router, card, setApiError)
                          if (result && !result.connected) {
                            enable_items[card.index] = result
                            setEnableItems([...enable_items]);
                          }
                        }}>
                        {getIntegrationsStatus(card, t)}
                    </Button>}
                        </div>
                      </div>
                    </div>
                  );
                }
             })}
            </div>
          </div>) : ''}


          {enable_items.length > 0 ?
          (<div className={`${Styles.IntegrationView}`}>
            <div className={`${Styles.IntegrationView__Title}`}>
                <h1>Video Conferencing</h1>
            </div>
            <div className={`${Styles.IntegrationView__Subheading}`}>
              <p className={`mt10`}>Connect your video conferencing tool to automatically set up a video conference for your video interviews</p>
            </div>
             <div className={`${Styles.IntegrationView__FlexFlow}`}>{enable_items.map((card, index) => {
                if ((card.name == "Teams") || (card.name == "Zoom")){
                  return (
                    <div className={`${Styles.IntegrationView__BoxWidth} ${Styles.IntegrationView__w100}`} key={index}>
                      <div className={`${Styles.IntegrationView__Box}`}>
                        {card.name == 'Zoom' ? (<div className={`${Styles.IntegrationView__BoxImage}`}>
                          {card.logo}<span className={`${Styles.IntegrationView__BoxImage__InfoIcon}`}>
                            <a href={zoom_document_url} target="_blank" style={{color: "#00325A"}}><InfoIcon/></a>
                          </span>
                        </div>) : (<div className={`${Styles.IntegrationView__BoxImage}`}>
                          {card.logo}
                        </div>)}
                        <div className={`${Styles.IntegrationView__ConnectButton}`}>
                            <Button buttonstyle={getButtonClass(card)} onClick={async (e) => {
                                const result = await connectDisconnectIntegration(e, router, card, setApiError)
                                  if (result && !result.connected) {
                                    enable_items[card.index] = result
                                    setEnableItems([...enable_items]);
                                  }
                                }}>
                                {getIntegrationsStatus(card, t)}
                            </Button>
                        </div>
                      </div>
                    </div>
                  );
                }
             })}
             <div className={`${Styles.IntegrationView__BoxWidth} ${Styles.IntegrationView__w100}`}>
                      <div className={`${Styles.IntegrationView__Box}`}>
                        <div className={`${Styles.IntegrationView__BoxImage}`}>
                          <img src= "/images/pages/integration/google_meet.png" width="127px" alt="Google Meet"/>
                        </div>
                        <div className={`${Styles.IntegrationView__ViewMoreButton}`}>
                            <Button onClick={handleOpenPopup}>
                                VIEW DETAILS
                            </Button>
                        </div>
                      </div>
                    </div>
            </div>
          </div>) : ''}

          {enable_items.length > 0 ?
          (<div className={`${Styles.IntegrationView}`}>
            <div className={`${Styles.IntegrationView__Title}`}>
                <h1>Notifications</h1>
            </div>
            <div className={`${Styles.IntegrationView__Subheading}`}>
              <p className={`mt10`}>Receive notifications in Slack about key events related to your job and take an action if desired</p>
            </div>
             <div className={`${Styles.IntegrationView__FlexFlow}`}>{enable_items.map((card, index) => {
                if (card.name == "Slack"){
                  return (
                    <div className={`w50 ${Styles.IntegrationView__w100}`} key={index}>
                      <div className={`${Styles.IntegrationView__Box}`}>
                        <div className={`${Styles.IntegrationView__BoxImage}`}>
                          {card.logo}<span className={`${Styles.IntegrationView__BoxImage__InfoIcon} ml6-integration`}>
                            <a href={slack_document_url} target="_blank" style={{color: "#00325A"}}><InfoIcon/></a>
                          </span>
                        </div>
                        <div className={`${Styles.IntegrationView__ConnectButton}`}>
                            <Button buttonstyle={getButtonClass(card)} onClick={async (e) => {
                                const result = await connectDisconnectIntegration(e, router, card, setApiError)
                                  if (result && !result.connected) {
                                    enable_items[card.index] = result
                                    setEnableItems([...enable_items]);
                                  }
                                }}>
                                {getIntegrationsStatus(card, t)}
                            </Button>
                        </div>
                      </div>
                    </div>
                  );
                }
             })}
            </div>
          </div>) : ''}

          {showPopup && <IntegrationPopup setShowPopup={setShowPopup} onClose={handleClosePopup}/>}


          {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
          {isQuickSetup && <div className={`${Styles.SkipFinishButton} space`}>
            <div className= {`buttonolumngap ${Styles.Integration__SubmitSection}`}>
              <Button buttonstyle={ButtonStyle.secondarybtnborder} type="button" onClick={() => {
                setSkipModal(true)}}> Skip </Button>
              <Button buttonstyle={ButtonStyle.primarybtn} type="button" onClick={()=>{
                cronofyConnectedOrNot(step, router, activitiesAction);
              }}> Finish </Button>
            </div>
          </div>}

        </div>
      </motion.div>
    </div>
  );
}

MyIntegrations.layout = ClientDashboard;
export default MyIntegrations;